<app-cursors-wrapper></app-cursors-wrapper>
<app-loaders-wrapper></app-loaders-wrapper>
<!-- <button *ngIf="!editorViewService.overlayVisible" (click)="editorViewService.showOverlay()">Pokaż nakładkę</button>
<button *ngIf="editorViewService.overlayVisible" (click)="editorViewService.saveNewStrukture()">Zapisz zmianę</button>
  <div class="global-overlay" *ngIf="editorViewService.overlayVisible" >
  </div> -->
<router-outlet></router-outlet>
